import { assignJob, getFreePopulation, MAX_SMOKERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireSmokerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.smokehouse.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_SMOKERS * settlement.buildings.smokehouse.qty;
    if (settlement.jobs.smokers >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'smokers')) return false;
    settlement.production.smokehouse.progress.push(0);
    return true;
};
